import { resolve, resolveAll } from '../helpers/LinkMapper';
import config from '../config';
import TicketType from '../records/TicketType';

const RoversRangersTicketsService = {

    getAll () {
        return resolveAll(config.get('roversRangersTicketTypes')).as(TicketType);
    },

    getFirst () {
        return resolve(config.get('roversRangersTicketTypes')[0]).as(TicketType);
    }
};

export default RoversRangersTicketsService;



// WEBPACK FOOTER //
// ./src/services/RoversRangersTicketsService.js